import { createNavigateToNextOnboardingPageAction } from "@actions/navigateToNextOnboardingPageActionFactory"

const ORDERED_ONBOARDING_ROUTES = [
  "gender",
  "age",
  "company",
  "tryFirst",
  "unleashLook",
  "firstImpression",
  "tryFirstSub",
  "styleFeeling",
  "hairstyleFrequency",
  "boldLooks",
  "sharePhoto",
  "experimentingLook",
  "doingAmazing",
  "confidenceBoost",
  "futureLook",
  "personality",
  "compliment",
  "styleProfile",
  "readyToTransform",
  "photoUsage",
  "subscriptionCount",
  "almostThere",
] as const

const navigateToNextOnboardingPageAction =
  createNavigateToNextOnboardingPageAction(ORDERED_ONBOARDING_ROUTES)

export default navigateToNextOnboardingPageAction
